<template>
    <b-card :title="service_title" class="mr-1 ml-1">
        <!-- INFORMAZIONI SUL SERVIZIO -->
        <!-- Testo quando la componente è totale ( convenzione ) -->
        <b-row>
          <b-col class="alert alert-warning" role="alert">
              <h5><b-icon icon="exclamation-triangle"></b-icon> IMPORTANTE:</h5>
              <p>Si rende noto che nel rispetto degli artt. 51 e 100 del Testo Unico Imposte sui Redditi, il beneficiario del Piano Welfare può effettuare acquisti tramite la piattaforma web nella sezione "{{service_title}}":</p>
              <p>- solo per le finalità indicate al comma 1 dell'art. 100 (educazione, istruzione, ricreazione, assistenza sociale e sanitaria o culto);</p>
              <p>- solo per sé o per i familiari indicati nell'art.433 del Codice Civile vigente, richiamato dall'art. 12 del Testo Unico Imposte sui Redditi.</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <p>Di seguito l'elenco dei soggetti che, oltre al titolare del piano welfare, possono beneficiare dei servizi acquistati:</p>
              <ul>
              <li>il coniuge (non legalmente ed effettivamente separato)</li>
              <li>i figli (legittimi o legittimati o naturali o adottivi) anche adottivi, e, in loro mancanza, i discendenti prossimi (anche naturali)</li>
              <li>i genitori e, in loro mancanza, gli ascendenti prossimo, anche naturali; gli adottanti</li>
              <li>il partner nelle unioni civili (Legge 20 maggio 2016, n.76)</li>
              <!-- <li>i generi e le nuore</li>
              <li>il suocero e la suocera</li>
              <li>i fratelli e le sorelle germani o unilaterali, con precedenza dei germani sugli unilaterali</li> -->
              </ul>
          </b-col>
        </b-row>
        <!-- BOTTONE DI ACCESSO -->
        <b-row>
          <b-col>
              <!-- Per il form usiamo gli attributi "classici" e non effettuamo il submit con axios perchè ci serve il target "blank" per il redirect -->
              <!-- Il campo di input non lo prendiamo da bootstrap vue perchè hidden non è supportato -->
              <b-form target="_blank"
                  ref="sso_form"
                  method="POST"
                  :action="login_url">
                  <input type="hidden" name="d" :value="user_data">
                  <b-form-group id="group-ok-condizioni">
                      <b-form-checkbox
                        id="ok-condizioni"
                        name="ok-condizioni"
                        :value="true"
                        :unchecked-value="false"
                        v-model="conditions_checkbox"
                        required>
                        <span class="font-italic">Il/la sottoscritto/a dichiara, sotto la propria responsabilità, che i dati relativi ai familiari che verranno inseriti sulla piattaforma sono veritieri e si impegna a modificarli qualora avvenissero vicende modificative di tali dati. In caso di verifica di nominativo non appartenente all’elenco di cui sopra autorizzo Welfarebit srl ad emettere nei miei confronti regolare fattura per i servizi acquistati.</span>
                      </b-form-checkbox>
                  </b-form-group>
                  <!-- Il submit viene effettuato dalla funzione execute_sso la quale fa poi comparire la pagina di redirect alla home -->
                  <!-- non possiamo contrasegnare il pulsante come submit perchè se usiamo anche l'evento click questo impedisce il submit -->
                  <!-- stesso evitando l'apertura della pagina di tantosvago. -->
                  <b-button v-if="show_submit_btn" variant="primary" @click="execute_sso">Accedi al portale {{service_title}}</b-button>
              </b-form>
          </b-col>
        </b-row>
        <!-- Uno slot per del contenuto addizionale sotto al form -->
        <slot name="form-footer"></slot>
    </b-card>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'AmilonLoginPage',
  data () {
    return {
        // Checkbox di conferma delle condizioni
        conditions_checkbox: false,

        // Url di login e dati utente cifrati presi dal backend
        // sulla base della configurazione delle props.
        login_url: null,
        user_data: null
    }
  },
  computed : {
    /**
     * Visualizza o meno il bottone di invio del form sulla base del valore della checkbox.
     */
    show_submit_btn : function () {
      return  this.conditions_checkbox === true ? true : false;
    }
  },
  created : function () {
    /* Costruisco la stringa criptata con i dati utente e l'url di login */
    let data = { service: this.service };

    axios.post( apiUrl.welfareapi.create_acq_amilon100_login, data )
    .then( ( response ) => {
      this.user_data = response.data.enc_data;
      this.login_url = response.data.login_url;
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });

  },
  methods : {
    /**
     * Invia i dati del form per eseguire l'SSO poi visualizza la pagina
     * di redirect di cortesia la quale ci riporta infine alla home.
     */
    execute_sso : function () {
      // Prendiamo il form ed invochiamo manualmente l'evento submit
      // per inviare i dati.
      let form = this.$refs.sso_form;
      form.submit();
      this.$router.replace( { name : 'conv-redirect', params:  { page_title : this.service_title } });
    }
  },
  props : {
    /**
     * Titolo del servizio ( es. esperienze, viaggi etc... )
     */
    service_title: {
        type: String,
        required: true
    },
    /**
     * Servizio richiesto ( es. experiece, travel etc... )
     */
    service: {
        type: String,
        required: true
    }
  }
}
</script>

<style scoped>
</style>